<template>
  <div class="list row">
    <h2>Tipovi partnera</h2>
    <div class="actions d-flex flex-row-reverse">
      <button
        type="button"
        class="btn btn-primary bi bi-arrow-clockwise"
        @click="refreshData"
      />
      <button
        type="button"
        class="btn btn-success bi bi-plus"
        @click="addData"
      />
    </div>
    <data-table
      url="customer-types"
      :columns="columns"
      :templates="templates"
      :headings="headers"
      :actions="actions"
      ref="datatable"
      @yes="deleteData"
      name="customer-types"
    >
    </data-table>
  </div>
</template>

<script>
import CustomerTypesDataService from "../../services/customer-types.service";
import DataTable from "../widgets/DataTable.vue";
import ArticleForm from "./CustomerTypeForm.vue";

export default {
  name: "customer-types",
  components: {
    DataTable,
  },
  data() {
    return {
      columns: ["name", "edit"],
      headers: {
        name: "Naziv",
        edit: "",
      },
      templates: {},
      actions: {
        edit: { commp: ArticleForm },
        delete: {
          deleteData: this.deleteData,
          color: "danger",
          icon: "bi-trash",
        },
        // print: null,
      },
      currentTutorial: null,
      currentIndex: -1,
      title: "",
    };
  },
  methods: {
    refreshData() {
      this.$refs.datatable.onRefresh();
    },
    addData() {
      this.$store.commit("app/showModal", {
        modal: ArticleForm,
        params: { data: {}, title: "Dodaj novi" },
      });
    },
    deleteData(id) {
      CustomerTypesDataService.delete(id)
        .then((response) => {
          this.$store.commit("app/showAlert", {
            type: "success",
            message: response.data.message,
          });
          this.$store.commit("app/hideModal");
        })
        .catch((e) => {
          console.log(e);
          this.$store.commit("app/showAlert", {
            type: "danger",
            message: e,
          });
        });
    },
  },
};
</script>

<style scoped>
.list {
  text-align: left;
  /* max-width: 750px; */
  margin: auto;
}
</style>
